import { AbstractReportPmsApiService } from '../abstract-report.service';
import { PayoutCommissionReport } from "../../../models/reports/financial/payout-commission-report.model";

/**
 * @class PayoutCommissionReportPmsApiService
 * @extends {AbstractReportPmsApiService<PayoutCommissionReport>}
 */
export class PayoutCommissionReportPmsApiService extends AbstractReportPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return super.urlPattern + '/financial/payout-commission';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {PayoutCommissionReport}
     * @protected
     */
    newModel(attributes, ...params) {

        return new PayoutCommissionReport(attributes);
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/reports/financial/payout-commission-report.service.js